<template>
  <v-container fluid>
    <v-row class="child-flex">
      <v-card>
        <v-card-text>
          <v-card-title>
            ROI CsvDatasource Reports
            <refresh-spinner v-model="isRefreshingData" @click="fetchData"></refresh-spinner>
            <v-spacer></v-spacer>
            <v-text-field @keydown.native.escape="search = ''" label="Search" single-line clearable persistent-hint
              hint="Filter by name" v-model="search">
            </v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="primary" :to="{ name: 'new_csv_datasource_report_path' }">
              <v-icon left>mdi-plus</v-icon>
              New ROI for CsvDatasource Report
            </v-btn>
          </v-card-title>
        </v-card-text>
        <!-- TODO -->
        <v-data-table :headers="tableColumns" :items="filteredTableData" item-key="id" class="elevation-1">
          <template v-slot:item.name="{ item }">
            <router-link :to="{ name: 'show_csv_datasource_path', params: { id: item.report_csv_datasource.id } }">
              {{ item.name }}
            </router-link>
          </template>
          <!-- status -->
          <template v-slot:item.report_csv_datasource.status="{ item }">
            <v-chip v-if="item.report_csv_datasource.status" :color="dsStatusColor(item.report_csv_datasource.status)"
              text-color="white">{{ item.report_csv_datasource.status }}</v-chip>
          </template>
          <template v-slot:item.source_csv_datasource.name="{ item }">
            <router-link :to="{ name: 'show_csv_datasource_path', params: { id: item.source_csv_datasource.id } }">
              {{ item.source_csv_datasource.name }}
            </router-link>
          </template>
          <!-- TODO -->
          <template v-slot:item.actions="{ item }">
            <template v-for="(rowAction, index) in actions">
              <v-tooltip top :key="index">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" medium class="mr-2"
                     @click="executeAction(rowAction.action, item)">{{ rowAction.icon || rowAction.display(item) }}</v-icon>
                </template>
                <span>{{ rowAction.title }}</span>
              </v-tooltip>
            </template>
          </template>
        </v-data-table>
      </v-card>
    </v-row>
  </v-container>
</template>

<script setup>
import { CsvRoiReportsApi } from '@/services'
import { ref, onMounted, computed } from 'vue'
import RefreshSpinner from '@/components/ui/RefreshSpinner'
import useCurrentDealer from '@/composables/useCurrentDealer'
import { DatasourceApi } from '@/services'
import useFlashMessage from '@/composables/useFlashMessage'

const flash = useFlashMessage()
const dealer = useCurrentDealer()

const isRefreshingData = ref(false)
const search = ref('')
const tableColumns = ref([
  { text: 'ID', value: 'id' },
  { text: 'Name', value: 'name' },
  { text: 'Status', value: 'report_csv_datasource.status' },
  { text: 'Source Csv Datasource', value: 'source_csv_datasource.name' },
  { text: 'ROI Start Date', value: 'roi_start_date' },
  { text: 'ROI End Date', value: 'roi_end_date' },
  { text: 'Actions', value: 'actions' }
])

const actions = ref([
  { title: 'Download Report', action: 'handleDownloadReport', display: reportIcon },
  { title: 'Delete', action: 'handleDelete', icon: 'mdi-delete' }
])

const tableData = ref([])

const filteredTableData = computed(() => {
  if (search.value) {
    return tableData.value.filter(item =>
      item.name.toLowerCase().includes(search.value.toLowerCase()) ||
      item.source_csv_datasource.name.toLowerCase().includes(search.value.toLowerCase())
    )
  }
  return tableData.value
})

onMounted(async () => {
  fetchData()
})

async function fetchData() {
  const resp = await CsvRoiReportsApi.fetchCsvRoiReports(dealer.value.id)
  tableData.value = resp.data
}

async function executeAction(action, item) {
  this[action](item)
}

async function handleDownloadReport(item) {
  if (item.report_csv_datasource.status === 'complete') {
    await downloadReport(item.report_csv_datasource)
  } else {
    alert('Csv Datasource is not complete or has an error')
  }
}

function reportIcon(item) {
  if (item.report_csv_datasource.status === 'complete') {
    return 'mdi-download'
  } else {
    return 'mdi-download-off'
  }
}

async function downloadReport(csvDatasource) {
  try {
    const docId = csvDatasource.params.additional_docs[0].doc_id
    const url = await DatasourceApi.getCsvAdditionalDocumentUrl(csvDatasource, docId)
    const downloadLink = document.createElement('a')
    downloadLink.setAttribute('href', url)
    downloadLink.setAttribute('style', 'display:none')
    downloadLink.setAttribute('target', '_blank')
    document.body.append(downloadLink)

    setTimeout(function () {
      downloadLink.click()
      downloadLink.remove()
    }, null)
  } catch (error) {
    flash({
      showClose: true,
      message: 'Error downloading Report! ' + error.message,
      type: 'error'
    })
  }
}

async function handleDelete(row) {
  const shouldDelete = confirm('Are you sure you want to delete? This action can not be undone.')
  if (shouldDelete) {
    try {
    await CsvRoiReportsApi.deleteCsvRoiReport(row.id)
    await fetchData()
    flash({
      showClose: true,
      message: 'Deleted Datasource',
      type: 'mini',
      duration: 2000
      })
    } catch (error) {
      flash({
        showClose: true,
        message: 'Error Deleting Roi Report. ' + error.message,
        type: 'error',
        duration: 0
      })
    }
  }
}


function dsStatusColor(status) {
  switch (status) {
    case 'error':
      return 'red'
    case 'processing':
      return 'orange'
    case 'complete':
      return 'green'
  }
}
</script>
